import { Question } from '@phosphor-icons/react';
import { Button, Checkbox, Sheet, Text } from '@shh/ui';
import { Link } from 'react-router';
import { LAYERS, type Layer, type Layers } from '../../data/calendar';
import { calendarText } from '../../i18n/calendar';

const LAYER_LABEL: Record<Layer, string> = {
  holidays: calendarText.layerHolidays,
  birthdays: calendarText.layerBirthdays,
  school: calendarText.layerSchool,
  shifts: calendarText.layerShifts,
  waste: calendarText.layerWaste,
  subscriptions: calendarText.layerSubscriptions,
};

/** "Was steht im Kalender?" – what comes by itself can be switched off per device. */
export function LayersSheet({
  isOpen,
  onOpenChange,
  layers,
  onLayer,
  noRegion,
  canParent,
  onHelp,
}: {
  isOpen: boolean;
  onOpenChange: (o: boolean) => void;
  layers: Layers;
  onLayer: (l: Layer, on: boolean) => void;
  noRegion: boolean;
  canParent: boolean;
  onHelp?: () => void;
}) {
  return (
    <Sheet isOpen={isOpen} onOpenChange={onOpenChange} title={calendarText.layers}>
      <div className="flex flex-col gap-gap-sm">
        {LAYERS.map((l) => (
          <Checkbox key={l} isSelected={layers[l]} onChange={(on) => onLayer(l, on)}>
            {LAYER_LABEL[l]}
          </Checkbox>
        ))}
        {noRegion && (
          <Text size="sm" tone="secondary">
            {calendarText.noRegion}{' '}
            {canParent && (
              <Link to="/einstellungen#familie" className="font-bold underline">
                {calendarText.toSettings}
              </Link>
            )}
          </Text>
        )}
        <Text size="sm" tone="muted">
          {calendarText.layersHint}
        </Text>
        {onHelp && (
          <Button variant="secondary" icon={Question} onPress={onHelp} className="self-start">
            {calendarText.help}
          </Button>
        )}
      </div>
    </Sheet>
  );
}

/** The "?" (Mike, 18.10.: "Info-Button für die ganze Nutzung und Gesten"). */
export function HelpSheet({
  isOpen,
  onOpenChange,
}: {
  isOpen: boolean;
  onOpenChange: (o: boolean) => void;
}) {
  const lines = [
    calendarText.helpSwipe,
    calendarText.helpMonth,
    calendarText.helpWeekNumber,
    calendarText.helpWeek,
    calendarText.helpDay,
    calendarText.helpPeople,
    calendarText.helpAdd,
    calendarText.helpKeys,
  ];
  return (
    <Sheet isOpen={isOpen} onOpenChange={onOpenChange} title={calendarText.helpTitle}>
      <ul className="flex list-disc flex-col gap-gap-sm pl-inset-md">
        {lines.map((l) => (
          <li key={l}>
            <Text>{l}</Text>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
